import {
  Spin,
  Select,
  Button,
} from "antd";
import {
  PlusSquareOutlined,
} from "@ant-design/icons";
import { formatCurrency } from "../../helpers/currency";
import { NAIRA } from "../../defaults/utilities";
import { userStore } from "../../store/userStore";
import DataTable from "../common/table";
import VoucherEditRefactored from "./VoucherEditRefactored";

const { Option } = Select;

const NoDataComponent = () => {
  return <h2>No data, Please Select Year</h2>;
};

function VoucherList({
  vouchers,
  vouchersLoading,
  totalElements,
  currentPage,
  pageSize,
  onPageChange,
  years,
  onYearSearch,
  onOpenModal,
}) {
  const currentUser = userStore((state) => state.user);

  const voucherDataColumns = [
    {
      title: "Name",
      key: "name",
      dataIndex: "name",
    },
    {
      title: "Creator",
      key: "creator",
      dataIndex: "creator",
      render: (creator) => creator.name,
    },
    {
      title: "Financial Year",
      key: "year",
      dataIndex: "financialYear",
      render: (year) => year.value,
    },
    {
      title: "Amount",
      key: "total",
      dataIndex: "total",
      render: (total) => `${NAIRA} ${formatCurrency(total)}`,
    },
    {
      title: "Submitted",
      key: "submitted",
      dataIndex: "submitted",
      render: (submitted) =>
        submitted ? (
          <span style={{ color: "green" }}>Submitted</span>
        ) : (
          <span style={{ color: "red" }}>Not Submitted</span>
        ),
    },
    {
      title: "Status",
      key: "closed",
      dataIndex: "closed",
      render: (closed) =>
        closed ? <span style={{ color: "green" }}>Closed</span> : <span style={{ color: "red" }}>Open</span>,
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, voucher) => <VoucherEditRefactored voucher={voucher} />,
    },
  ];

  return (
    <>
      <div className="info-bar">
        <div>
          <div>
            <Select
              showSearch
              placeholder="Filter By Year"
              onChange={onYearSearch}
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              style={{
                width: 150,
              }}
              options={[
                ...years.map((year) => ({
                  value: year.id,
                  label: year.value,
                })),
              ]}
            />
          </div>
        </div>
        {currentUser?.roles?.includes("ADVANCE") && (
          <div style={{ display: "flex", gap: "1em" }}>
            <Button
              style={{ backgroundColor: "green", color: "#FFFFFF" }}
              onClick={onOpenModal}
            >
              <PlusSquareOutlined />
              New Voucher
            </Button>
          </div>
        )}
      </div>

      <div className="table-section">
        <Spin spinning={vouchersLoading}>
          <div style={{ marginBottom: "2em" }}>
            <DataTable
              cols={voucherDataColumns}
              data={vouchers}
              locale={{
                emptyText: <NoDataComponent />,
              }}
              pagination={{
                current: currentPage,
                pageSize: pageSize,
                total: totalElements,
                onChange: onPageChange,
                showSizeChanger: true,
                showQuickJumper: true,
                showTotal: (total) => `Total ${total} items`
              }}
            />
          </div>
        </Spin>
      </div>
    </>
  );
}

export default VoucherList;